<!-- 工作台 -->
<template>
  <div>
    <div class="form-main">
      <el-form :model="formData" ref="formData" label-width="120px" class="formData">
        <div>
          <el-form-item label="纳税人名称">
            <span v-if="!isEdit" style="font-size:16px;font-weight:bold;">{{formData.Taxpayer}}</span>
            <el-input v-if="isEdit" v-model="formData.Taxpayer"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="税务登记号">
            <span v-if="!isEdit" style="font-size:16px;font-weight:bold;">{{formData.RegistrationNum}}</span>
            <el-input v-if="isEdit" v-model="formData.RegistrationNum"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="税务登记地址">
            <span v-if="!isEdit" style="font-size:16px;font-weight:bold;">{{formData.RegistrationAddr}}</span>
            <el-input v-if="isEdit" v-model="formData.RegistrationAddr"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="税务联系电话">
            <span v-if="!isEdit" style="font-size:16px;font-weight:bold;">{{formData.RegistrationPhNum}}</span>
            <el-input v-if="isEdit" v-model="formData.RegistrationPhNum"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="税务开户行名称">
            <span v-if="!isEdit" style="font-size:16px;font-weight:bold;">{{formData.OpeningBank}}</span>
            <el-input v-if="isEdit" v-model="formData.OpeningBank"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="税务开户行账号">
            <span v-if="!isEdit" style="font-size:16px;font-weight:bold;">{{formData.OpeningAccount}}</span>
            <el-input v-if="isEdit" v-model="formData.OpeningAccount"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="相关备注">
            <span v-if="!isEdit" style="font-size:16px;font-weight:bold;">{{formData.Remark}}</span>
            <el-input
              type="textarea"
              maxlength="140"
              show-word-limit
              v-if="isEdit"
              v-model="formData.Remark"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button v-if="!isEdit" class="btn-primary" @click="changeToEdit">编辑开票信息</el-button>
        <el-button v-if="!isEdit" @click="cancel()">关闭</el-button>
        <el-button v-if="isEdit" class="btn-primary" @click="submitInvoiceForm">提交</el-button>
        <el-button v-if="isEdit" @click="changeToEdit">取消编辑</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["EntpCusId"], // type 1 新增 2 编辑    source 1 客户 2 供应商
  name: "",
  data() {
    let userMsg=this.$util.getLocalStorage("userMsg");
    return {
      userMsg:userMsg,
      isEdit: false,
      formData: {
        EntpCusId: this.EntpCusId,
        EntpId: userMsg.EntpId,
        Taxpayer: "",
        RegistrationNum: "",
        RegistrationAddr: "",
        RegistrationPhNum: "",
        OpeningBank: "",
        OpeningAccount: "",
        Remark: ""
      }
    };
  },
  mounted() {
    this.getInvoiceInfo();
  },
  methods: {
    getInvoiceInfo() {
      let url = "/api/EntpCustomers/GetEnterpriseCustomerInvoiceInfo";
      this.$util
        .axiosGet({
          url: url,
          data: {
            EntpCusId: this.EntpCusId
          }
        })
        .then(res => {
          if (res.data) {
            this.formData = res.data;
            if (res.data.Taxpayer) this.isEdit = false;
            else this.isEdit = true;
          } else this.isEdit = true;
        })
        .catch(() => {});
    },
    // 提交表单
    submitInvoiceForm() {
      let that = this;
      let url = "/api/EntpCustomers/SaveEnterpriseCustomerInvoiceInfo";
      that.$util
        .axiosPost({
          url: url,
          data: that.formData
        })
        .then(() => {
          this.isEdit = false;
        })
        .catch(() => {
        });
    },
    cancel() {
      this.$emit("closeInvoiceInfoDialog");
    },
    changeToEdit() {
      if (this.isEdit) this.isEdit = false;
      else this.isEdit = true;
    }
  }
};
</script>
<style lang="less" scoped>
.form-value {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  color: #606266;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  width: 100%;
}
.form-column {
  width: 33.33%;
}
.dialog-footer {
  text-align: right;
}
</style>
